import React from 'react';

import MenuIcon from '@mui/icons-material/Menu';
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Link,
  MenuItem,
  MenuList,
} from '@mui/material';
import { NavLinkInterface } from 'server/config-cache/types';

import NavBarLayout from '../NavBarLayout';
import UserMenu from '../UserMenu';

type Props = {
  isAuthenticated: boolean;
  logout: () => Promise<void>;
  loginDisplayText: string;
  userMenuLinks: {
    top: NavLinkInterface[];
    account: NavLinkInterface[];
    bottom: NavLinkInterface[];
  };
  drawerMenu: {
    links: NavLinkInterface[];
    cta: NavLinkInterface;
  };
};

const MobileNavBar: React.FC<Props> = ({
  drawerMenu,
  isAuthenticated,
  loginDisplayText,
  logout,
  userMenuLinks,
}) => {
  const [showDrawer, setShowDrawer] = React.useState(false);

  return (
    <Box>
      <NavBarLayout
        leftComponent={
          !isAuthenticated && (
            <IconButton
              disableRipple
              onClick={() => {
                setShowDrawer(true);
              }}
            >
              <MenuIcon />
            </IconButton>
          )
        }
        rightComponent={
          isAuthenticated ? (
            <UserMenu
              logout={logout}
              accountLinks={userMenuLinks.account}
              bottomLinks={userMenuLinks.bottom}
              topLinks={userMenuLinks.top}
            />
          ) : (
            <Box>
              <Button variant="text" href={'/login'}>
                {loginDisplayText}
              </Button>
            </Box>
          )
        }
      />
      <Drawer
        anchor="bottom"
        open={showDrawer}
        onClose={() => {
          setShowDrawer(false);
        }}
        variant="temporary"
      >
        <MenuList>
          {drawerMenu.links.map((l) => (
            <Link
              key={`${l.url}-${l.displayText}`}
              href={l.url}
              sx={{ textDecoration: 'none' }}
            >
              <MenuItem sx={{ padding: '0.625rem 1.875rem' }}>
                {l.displayText}
              </MenuItem>
            </Link>
          ))}
          <MenuItem sx={{ paddingLeft: '1.875rem', paddingBottom: '1.25rem' }}>
            <Button variant="contained" size="medium" href={drawerMenu.cta.url}>
              {drawerMenu.cta.displayText}
            </Button>
          </MenuItem>
        </MenuList>
      </Drawer>
    </Box>
  );
};

export default MobileNavBar;
